export default __webpack_public_path__ + "4f3be9e35cbca9fcab43dde715faadd8.svg";